import styled from "styled-components";
import { blue, green } from "../../styles/variables.style";

export const StartWrapper = styled.div`
  display: flex;
  height: 100vh;

  .left {
    flex: 1;
    background-color: ${green};
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 400px;
      cursor: pointer;
    }
  }

  .right {
    flex: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding-bottom: 50px;

    .description {
      margin-bottom: 30px;
      padding: 0px 20% 0px 20%;
      p {
        font-size: 18px;
        color: grey;
        &.sorry {
          font-size: 32px;
          color: black;
          font-weight: bold;
          svg {
            width: 30px;
            -moz-transform: scale(-1, 1);
            -webkit-transform: scale(-1, 1);
            -o-transform: scale(-1, 1);
            -ms-transform: scale(-1, 1);
            transform: scale(-1, 1);
            margin-left: 10px;
          }
        }
        strong {
          color: black;
        }
      }
    }

    .form {
      display: flex;
      justify-content: center;
    }
    input::placeholder {
      color: grey;
    }
  }

  p {
    padding-top: 5px;
  }

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 0px;
    margin-bottom: 100px;
    .description {
      margin-bottom: 0px !important;
      padding: 0px !important;
    }
    .ant-row {
      width: 100% !important;
    }
    .right {
      padding: 0px;
      max-width: 90%;
      padding-bottom: 100px;
    }
  }
`;
